import Vue from 'vue';
import WorkAlertContainer from '@/components/global_components/alerts/WorkAlertContainer';
import WorkAlert from '@/components/global_components/alerts/WorkAlert';

Vue.component('WAlertContainer', WorkAlertContainer);
Vue.component('WAlert', WorkAlert);
